import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Row, Col } from "@neumetric/blueprint-lib/components";
import { isAuditee, getCurrentUser } from "@neumetric/blueprint-lib/store";
import EmptyTrackerEvalImg from "../../assets/images/auditor_empty_tracker_eval.png";

export const TrackerColumns = [
  {
    dataIndex: "audit_id",
    typeRepresentation: "LINK",
    title: "Audit ID",
    width: "8%",
  },
  {
    dataIndex: "title",
    typeRepresentation: "TEXT",
    title: "Title",
    width: "31%",
    semantics: {
      ellipsisFlag: true,
    },
  },
  {
    dataIndex: "start_date",
    typeRepresentation: "TEXT",
    title: "Planned Date",
    width: "11%",
    sortableFlag: true,
  },
  {
    dataIndex: "status",
    typeRepresentation: "DOT",
    title: "Status",
    width: "12%",
    sortableFlag: true,
    filterFlag: true,
    editablePolicy: "ALWAYS",
    editableFlag: true,
    inputProps: {
      attribute: "status",
      template: "DOT",
      classes: { input: "fs-16", root: "mb-0" },
      onChangeMode: "CONFIRM",
    },
  },
  {
    dataIndex: "progress",
    typeRepresentation: "TEXT",
    title: "Progress",
    width: "11%",
  },
  {
    dataIndex: "gaps",
    typeRepresentation: "TEXT",
    title: "Gaps",
    width: "5%",
    align: { cell: "center" },
  },
  {
    dataIndex: "gap_score",
    typeRepresentation: "TEXT",
    title: "Gap Score",
    width: "7%",
    align: { cell: "center" },
  },
  {
    dataIndex: "gap_serverity",
    typeRepresentation: "DOT",
    title: "Gap Severity",
    width: "9%",
    align: { cell: "right" },
  },
  {
    dataIndex: "actions",
    typeRepresentation: "LINK",
    title: "Actions",
    width: "6%",
  },
];
export const EmptyTrackerComponent = () => {
  const navigate = useNavigate();
  const currentUser = useSelector(getCurrentUser);
  return (
    <Row
      className="w-100 h-100"
      justify="center"
      align="center"
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "auto",
      }}
    >
      <Row justify="center" align="center" style={{ gap: 50 }}>
        {/* LEFT TEXT BLOCK */}
        <Col
          style={{
            maxWidth: 320,
            textAlign: "left",
          }}
        >
          <div className="ff-exo2 f17 line-24 text-subtitle">
            Audit Register is currently empty!
          </div>
          {!isAuditee(currentUser) && (
            <>
              <div className="ff-exo2 f17 line-24 text-subtitle">
                Create a New audit...
              </div>

              <Button
                className="mt-24"
                icon="ADD"
                label="New Audit"
                classes={{ icon: "fs-14 fw-400" }}
                onClick={() => navigate("/A/T/new")}
              />
            </>
          )}
        </Col>

        {/* RIGHT IMAGE */}
        <img
          src={EmptyTrackerEvalImg}
          alt="eval"
          style={{
            width: 180,
            height: "auto",
          }}
        />
      </Row>
    </Row>
  );
};
export const DetailsFields = [
  {
    attribute: "title",
    typeRepresentation: "TEXT",
    label: "Title:",
    readOnly: true,
    labelAlign: "middle",
    classes: { root: "w-100 mb-[1rem]", label: "w-[11rem]" },
  },
  {
    attribute: "model",
    typeRepresentation: "TEXT",
    label: "Blueprint:",
    readOnly: true,
    labelAlign: "middle",
    classes: { root: "w-100 mb-[1rem]", label: "w-[11rem]" },
  },
  {
    attribute: "desc",
    typeRepresentation: "TEXT",
    label: "Description:",
    readOnly: true,
    classes: {
      root: "w-100 mb-[1rem]",
      label: "w-[11rem]",
      input: "bg-contrast",
    },
  },
  {
    attribute: "audit_type",
    typeRepresentation: "TEXT",
    label: "Audit Type:",
    readOnly: true,
    labelAlign: "middle",
    classes: {
      root: "w-50 mb-[1rem]",
      input: "text-caps fs-16",
      label: "w-[11rem]",
    },
  },
  {
    attribute: "status",
    typeRepresentation: "DROPDOWN",
    label: "Status:",
    readOnly: true,
    template: "DOT",
    labelAlign: "middle",
    classes: { root: "w-50 mb-[1rem]", label: "w-[11_9rem]" },
  },
  {
    attribute: "assessor",
    typeRepresentation: "HTML",
    label: "Assessor:",
    readOnly: true,
    labelAlign: "top",
    classes: { root: "w-45 mb-[1rem]", label: "w-[11rem]", input: "fs-16" },
  },
  {
    typeRepresentation: "HTML",
    attribute: "auditee",
    label: "Responder:",
    readOnly: true,
    labelAlign: "top",
    classes: { root: "w-50 mb-[1rem]", label: "w-[11_9rem]", input: "fs-16 " },
  },
  {
    typeRepresentation: "DATE",
    attribute: "start_date",
    label: "Planned Date:",
    readOnly: true,
    labelAlign: "middle",
    format: "ddd, DD-MMM-YYYY",
    classes: { root: "w-50 mb-[1rem]", label: "w-[11rem]", input: "pl-0" },
  },
  {
    typeRepresentation: "DATE",
    attribute: "end_date",
    label: "Target Date:",
    readOnly: true,
    labelAlign: "middle",
    format: "ddd, DD-MMM-YYYY",
    classes: { root: "w-50 mb-[1rem]", label: "w-[10_3rem]" },
  },
  {
    typeRepresentation: "DATE",
    attribute: "actual_start_date",
    label: "Start Date:",
    readOnly: true,
    labelAlign: "middle",
    format: "ddd, DD-MMM-YYYY",
    classes: {
      root: "w-50 mb-[1rem]",
      label: "w-85-px",
      input: "no-left-padding",
    },
  },
  {
    typeRepresentation: "TEXT",
    attribute: "actual_end_date",
    label: "Complete Date:",
    readOnly: true,
    labelAlign: "middle",
    classes: { root: "w-50 mb-[1rem]", label: "w-[11_9rem]", input: "pl-0" },
  },
];
export const NewAuditFormFields = [
  {
    label: "Blueprint",
    attribute: "lib1_model_id",
    typeRepresentation: "DROPDOWN",
    placeholder: "Blueprint",
    classes: { root: "w-100", label: "w-[11_7rem]" },
    required: true,
    showAsterisk: false,
  },
  {
    label: "Audit Title",
    attribute: "title",
    typeRepresentation: "TEXT",
    rows: "15",
    placeholder: "Title",
    classes: { root: "w-100", label: "w-[11_7rem]" },
    required: true,
    showAsterisk: false,
  },
  {
    label: "Description",
    attribute: "desc",
    typeRepresentation: "TEXTAREA",
    rows: 9,
    placeholder: "Description",
    classes: { root: "w-100", label: "w-[11_7rem]" },
    required: true,
    showAsterisk: false,
  },
  {
    label: "Audit Type",
    attribute: "audit_type",
    typeRepresentation: "DROPDOWN",
    placeholder: "Audit Type",
    classes: { root: "w-27", label: "w-[11_7rem]" },
    labelAlign: "middle",
    required: true,
    showAsterisk: false,
  },
  {
    label: "Planned Date",
    attribute: "start_date",
    typeRepresentation: "DATE",
    placeholder: "select date",
    format: "ddd, DD-MMM-YYYY",
    classes: { root: "w-32", label: "w-105-px" },
    required: true,
    labelAlign: "middle",
    showAsterisk: false,
  },
  {
    label: "Target Date",
    attribute: "end_date",
    typeRepresentation: "DATE",
    placeholder: "select date",
    classes: { root: "w-32", label: "w-100-px" },
    required: true,
    format: "ddd, DD-MMM-YYYY",
    labelAlign: "middle",
    showAsterisk: false,
  },
  {
    label: "Assessor",
    attribute: "governor",
    typeRepresentation: "DROPDOWN",
    placeholder: "multiselect possible",
    classes: { root: "w-49", label: "w-[11_7rem]" },
    required: true,
    multiSelection: true,
    hideSelectedOptions: false,
    labelAlign: "middle",
    showAsterisk: false,
  },
  {
    label: "Responder",
    attribute: "user",
    typeRepresentation: "DROPDOWN",
    placeholder: "multiselect possible",
    classes: { root: "w-49", label: "w-80-px" },
    required: true,
    multiSelection: true,
    hideSelectedOptions: false,
    labelAlign: "middle",
    showAsterisk: false,
  },
  {
    label: "Report Format",
    attribute: "report_format",
    typeRepresentation: "DROPDOWN",
    placeholder: "ISO 27001",
    classes: { root: "w-100", label: "w-[11_7rem]" },
    required: true,
    showAsterisk: false,
  },
];
